export default "__VITE_ASSET__eC_j29Jc__"